import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Printer Outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-printer-outline',
    templateUrl: './icon-printer-outline.component.html',
    styleUrls: ['./icon-printer-outline.component.scss'],
    standalone: false
})
export class IconPrinterOutlineComponent {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
